const configurableVariables = {
    facebook: 'https://es-la.facebook.com/pages/category/Local-Business/Big-Burger-130190660344224/',
    instagram: 'https://www.instagram.com/bigburgeroficial/',
    msInCarousel: 6000
}

export default configurableVariables;